import { render, staticRenderFns } from "./FacebookShare.vue?vue&type=template&id=09d62d2a&scoped=true"
import script from "./FacebookShare.vue?vue&type=script&lang=ts"
export * from "./FacebookShare.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d62d2a",
  null
  
)

export default component.exports